ux-iws-nb-all-in-one {
    display: block;
    padding: 15px;

    @media (min-width: 568px) {
        padding: 30px;
    }

    @media (min-width: 1440px) {
        padding-left: calc(100% / 12);
        padding-right: calc(100% / 12);
    }
}
